import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Bijgewerkt:',
  breadcrumbs: {
    home: 'Home',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Waarom u ons kunt vertrouwen',
        details: {
          text: '<h2>Waarom u ons kunt vertrouwen</h2><p>Artikelen op Natu.Care zijn geschreven op basis van wetenschappelijk onderzoek, gegevens van overheidswebsites en andere betrouwbare bronnen. De teksten zijn geschreven in samenwerking met artsen, voedingsdeskundigen en andere gezondheids- en schoonheidsexperts. Artikelen worden vóór publicatie en tijdens belangrijke updates gecontroleerd.</p>.',
          footerText: '<p>Lees meer over ons <a href="/nl/over-ons/redactieproces">redactieproces</a></p>.'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informatie over advertenties',
        details: {
          text: '<h2>Informatie over advertenties</h2><p>Inhoud op Natu.Care kan links bevatten naar producten waarvan we een commissie kunnen ontvangen. Bij het creëren van inhoud houden we ons aan hoge redactionele standaarden en zorgen we ervoor objectief te zijn over de besproken producten. De aanwezigheid van affiliate links wordt niet gedicteerd door onze partners, en we selecteren de producten die we beoordelen volledig onafhankelijk.</p>.',
          footerText: '<p>Lees meer over onze <a href="/nl/algemene-voorwaarden">algemene voorwaarden</a></p>.',
        }
      }
    ],
    tooltip: {
      labelVerified: 'Geverifieerd door een expert',
      footerText: '<p>Lees meer over ons <a href="/nl/over-ons/redactieproces">redactieproces</a></p>.'
    }
  },

  mediabar: {
    heading: 'Media over ons:',
    href: '/nl/over-ons',
    title: 'Media over ons:',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Zorg voor een gezond lichaam',
    description: `Probeer de hoogwaardige supplementen van Natu.Care`,
    button: {label: 'Bekijk producten', href: 'https://natu.shop/collections'},
    picture: {alt: 'Jonge, mooie vrouwen met een goede huidconditie'}
  },

  authorship: {
    heading: 'Redactie',
    link: {
      label: 'Ontmoet het team',
      href: '/nl/over-ons/redactie'
    }
  },

  similarArticles: {
    headingBlogList: 'Artikelen',
    headingBlogPost: 'Vergelijkbare artikelen'
  }  
};